/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum InternalApiIndexType {
    PERSON = 'PERSON',
    TRANSACTION = 'TRANSACTION',
    DOW_JONES = 'DOW_JONES'
}


export function instanceOfInternalApiIndexType(value: any): boolean {
    for (const key in InternalApiIndexType) {
        if (Object.prototype.hasOwnProperty.call(InternalApiIndexType, key)) {
            if (InternalApiIndexType[key as keyof typeof InternalApiIndexType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function InternalApiIndexTypeFromJSON(json: any): InternalApiIndexType {
    return InternalApiIndexTypeFromJSONTyped(json, false);
}

export function InternalApiIndexTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiIndexType {
    return json as InternalApiIndexType;
}

export function InternalApiIndexTypeToJSON(value?: InternalApiIndexType | null): any {
    return value as any;
}

export function InternalApiIndexTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): InternalApiIndexType {
    return value as InternalApiIndexType;
}

